export class TrackingSettings {
    static NAME_OF_CLASS = 'TrackingSettings';
    public ShowAllContestants: boolean = false;

    public ShowOnlyContestantsWithDevices: boolean = false;
}
